module.exports = __webpack_public_path__ + "img/synopsis-img2.0616af0a.jpg";